import(/* webpackMode: "eager" */ "/vercel/path0/components/commercial/commercial.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/commercial/savings-calculator.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/commercial/WindowFilmSavingsCalculator.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
